import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerCloseButton,
  DrawerOverlay,
  DrawerHeader,
  VStack,
  HStack,
  Icon,
  Text,
} from '@chakra-ui/react';

import { IoSearchOutline, IoLogIn } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';

import { getNavList } from './navList';
import { isServiceShutdown } from '~/config/serviceShutdown';

import { useParams, useNavigate } from 'react-router-dom';

type NavDrawerProps = {
  isOpen: boolean;
  isLogin: boolean;
  onClose: () => void;
  onLoginModalOpen: () => void;
  onLogout: () => void;
  onSearchModalOpen: () => void;
};

export default function NavDrawer({
  isOpen,
  isLogin,
  onClose,
  onLoginModalOpen,
  onLogout,
  onSearchModalOpen,
}: NavDrawerProps) {
  const { storeId, groupId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const navList = getNavList();
  const isShutdown = isServiceShutdown();

  const handleNavigate = (path: string) => {
    if (storeId && groupId) {
      return navigate(`/${storeId}/group/${groupId}/${path}`);
    }

    if (storeId) {
      return navigate(`/${storeId}/${path}`);
    }
  };

  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="left" size="xs">
      <DrawerOverlay />
      <DrawerContent maxW="250px">
        <DrawerHeader />
        <DrawerCloseButton
          bg="wsBlack"
          color="white"
          borderRadius="full"
          _focus={{
            boxShadow: 'unset',
          }}
        />
        <DrawerBody>
          <VStack align="stretch" spacing={6}>
            {navList.map(({ title, icon, link }) => {
              return (
                <HStack
                  key={title}
                  align="center"
                  cursor="pointer"
                  onClick={() => handleNavigate(link)}
                >
                  <Icon as={icon} boxSize="1.5rem" />
                  <Text fontSize="lg">{t(title)}</Text>
                </HStack>
              );
            })}
            {!isShutdown && (
              <HStack align="center" cursor="pointer" onClick={onSearchModalOpen}>
                <Icon as={IoSearchOutline} boxSize="1.5rem" />
                <Text fontSize="lg">{t('nav.search')}</Text>
              </HStack>
            )}
            <HStack
              align="center"
              cursor="pointer"
              onClick={() => (isLogin ? onLogout() : onLoginModalOpen())}
            >
              <Icon as={IoLogIn} boxSize="1.5rem" />
              <Text fontSize="lg">{isLogin ? t('nav.logout') : t('nav.login')}</Text>
            </HStack>
          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
